<script setup lang="ts">
import { useMMStore } from '@/store/MarvelMachine'
const mm = useMMStore()

const toggle = () => {
  mm.setAnimationToggle()
}
</script>

<template>
  <div class="marvel-machine-animation-toggle" @click="toggle()" :class="{ spinnRunning: mm.game.isSpinRunning }">
    <div :class="`marvel-machine-animation-toggle__icon ${mm.game.animationToggle ? '' : 'inactive'}`"></div>
  </div>
</template>

<style lang="scss" scoped>
.marvel-machine-animation-toggle {
  width: calc(285px * var(--marvel-desktopRatio));
  height: calc(70px * var(--marvel-desktopRatio));
  position: absolute;
  right: calc(30px * var(--marvel-desktopRatio));
  top: calc(34px * var(--marvel-desktopRatio));
  background: url('@/assets/imgs/mavelmachine/marvelAnimationToggle/animation-toggle-bg.png') no-repeat center center /
    100% auto;
  z-index: 10;
  cursor: pointer;
  transition: opacity 0.3s;
  &.spinnRunning {
    cursor: auto;
    opacity: 0.7;
  }
}
.marvel-machine-animation-toggle__icon {
  width: calc(40px * var(--marvel-desktopRatio));
  height: calc(40px * var(--marvel-desktopRatio));
  position: absolute;
  right: calc(25px * var(--marvel-desktopRatio));
  top: 50%;
  transform: translate(0, -50%);
  background: url('@/assets/imgs/mavelmachine/marvelAnimationToggle/icon-animation-on.png') no-repeat center center /
    100% auto;

  transition: background 0.3s, transform 0.3s;

  /* &:hover,
  &:after {
    content: '';
    background-image: url('@/assets/imgs/mavelmachine/marvelAnimationToggle/icon-animation-hover.png') !important;
  } */
  &.inactive {
    transform: translate(calc(-36px * var(--marvel-desktopRatio)), -50%);
    background-image: url('@/assets/imgs/mavelmachine/marvelAnimationToggle/icon-animation-off.png');
  }
}

/* @media (max-width: 1300px) {
  .marvel-machine-animation-toggle {
    width: 20vw;
    height: 5vw;
    right: 2vw;
    top: 3vw;
  }
  .marvel-machine-animation-toggle__icon {
    width: 3.2vw;
    height: 3.2vw;
    right: 1.5vw;
    &.inactive {
      transform: translate(-3vw, -50%);
    }
  }
} */

/* @media #{$tabletForMarvel} {
  .marvel-machine-animation-toggle {
    width: 20vw;
    height: 5vw;
    right: 2vw;
    top: 3vw;
  }
  .marvel-machine-animation-toggle__icon {
    width: 3.2vw;
    height: 3.2vw;
    right: 1.5vw;
    &.inactive {
      transform: translate(-3vw, -50%);
    }
  }
} */

@media #{$mobileForMarvel} {
  .marvel-machine-animation-toggle {
    width: 24vw;
    height: 6vw;
    right: auto;
    left: 3.5vw;
    top: 4.4vw;
  }
  .marvel-machine-animation-toggle__icon {
    width: 4vw;
    height: 4vw;
    right: 2vw;

    &.inactive {
      transform: translate(-3vw, -50%);
    }
    &:hover {
    }
  }
}
</style>
